import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {lightTheme} from '@components/@theme/lightTheme';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';

interface FixedLabelPopperProps {
  anchorEl: any;
  open: boolean;
  placement: 'right' | 'bottom';
  setLabelOpen: (open: boolean) => void;
}

export const FixedLabelPopper: React.FC<FixedLabelPopperProps> = ({
  anchorEl,
  open,
  placement,
  setLabelOpen,
  children,
}) => {
  const {paperLabel} = useStyles(lightTheme);
  return (
    <Popper
      anchorEl={anchorEl.current}
      open={open}
      transition
      placement={placement}
      disablePortal={false}
      modifiers={{
        flip: {
          enabled: true,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'scrollParent',
        },
      }}>
      {({TransitionProps}) => (
        <Fade {...TransitionProps} timeout={350}>
          <Tooltip title="Click to hide">
            <Paper elevation={4} className={paperLabel} onClick={() => setLabelOpen(false)}>
              {children}
            </Paper>
          </Tooltip>
        </Fade>
      )}
    </Popper>
  );
};

const useStyles = makeStyles(theme => ({
  paperLabel: {
    cursor: 'pointer',
    marginTop: 3,
    padding: theme.spacing(1),
  },
}));
